/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InstagramAccountDto } from '../models/InstagramAccountDto';
import type { IntegrationResponseDto } from '../models/IntegrationResponseDto';
import type { IntegrationsListResponseDto } from '../models/IntegrationsListResponseDto';
import type { SelectInstagramAccountDto } from '../models/SelectInstagramAccountDto';
import type { SelectInstagramAccountResponseDto } from '../models/SelectInstagramAccountResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IntegrationsService {
    /**
     * List all integrations for the current business
     * @returns IntegrationsListResponseDto
     * @throws ApiError
     */
    public static integrationControllerGetIntegrationsV1(): CancelablePromise<IntegrationsListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations',
        });
    }
    /**
     * Get integration status for a specific provider
     * @param provider Integration provider (e.g. instagram)
     * @returns IntegrationResponseDto
     * @throws ApiError
     */
    public static integrationControllerGetIntegrationStatusV1(
        provider: string,
    ): CancelablePromise<IntegrationResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations/{provider}/status',
            path: {
                'provider': provider,
            },
        });
    }
    /**
     * Disconnect an integration
     * @param provider Integration provider to disconnect
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerDisconnectIntegrationV1(
        provider: string,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/{provider}/disconnect',
            path: {
                'provider': provider,
            },
        });
    }
    /**
     * Clear a provider account restriction (user declares it fixed)
     * @param provider Integration provider to un-restrict
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerClearRestrictionV1(
        provider: string,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/{provider}/clear-restriction',
            path: {
                'provider': provider,
            },
        });
    }
    /**
     * List Facebook Pages the current user can see
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerListFacebookPagesV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations/facebook/pages',
        });
    }
    /**
     * Select a Facebook Page for publishing
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerSelectFacebookPageV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/facebook/select-page',
        });
    }
    /**
     * Begin connecting a Page via a fallback publishing partner
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerCreateFallbackConnectSessionV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/fallback/connect-session',
        });
    }
    /**
     * List Pages linked through a fallback publishing partner
     * @param provider
     * @param externalUserId
     * @param platform
     * @param connectAttemptId
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerListFallbackPagesV1(
        provider: string,
        externalUserId: string,
        platform: string,
        connectAttemptId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations/fallback/pages',
            query: {
                'provider': provider,
                'externalUserId': externalUserId,
                'platform': platform,
                'connectAttemptId': connectAttemptId,
            },
        });
    }
    /**
     * Persist a Page connected via a fallback publishing partner
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerSelectFallbackPageV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/fallback/select-page',
        });
    }
    /**
     * List LinkedIn Company Pages the connected member administers
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerListLinkedInTargetsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations/linkedin/targets',
        });
    }
    /**
     * Select a LinkedIn Company Page to publish to
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerSelectLinkedInTargetV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/linkedin/select-target',
        });
    }
    /**
     * Get the Instagram Business account linked through Composio
     * @returns InstagramAccountDto
     * @throws ApiError
     */
    public static integrationControllerGetInstagramAccountV1(): CancelablePromise<InstagramAccountDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations/instagram/account',
            errors: {
                400: `Instagram not connected`,
            },
        });
    }
    /**
     * Persist the Instagram Business account connected via Composio
     * @param requestBody
     * @returns SelectInstagramAccountResponseDto
     * @throws ApiError
     */
    public static integrationControllerSelectInstagramAccountV1(
        requestBody: SelectInstagramAccountDto,
    ): CancelablePromise<SelectInstagramAccountResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/instagram/select-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `The newly authorized account differs from the previously connected one. Body carries \`previousHandle\` + \`newHandle\`; confirm with the user and re-call with \`force: true\`.`,
            },
        });
    }
    /**
     * Resolve the gateway for a platform and begin connecting
     * @param provider Social platform to connect (e.g. facebook)
     * @returns any
     * @throws ApiError
     */
    public static integrationControllerCreateConnectSessionV1(
        provider: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/{provider}/connect-session',
            path: {
                'provider': provider,
            },
        });
    }
}
